<div class="survey-report-viewer-container" style="position: relative;">
  <button mat-icon-button aria-label="Close" (click)="dialogRef.close()" style="position: absolute; top: 8px; right: 8px; z-index: 1;">
    <span style="font-size: 24px; line-height: 1;">&times;</span>
  </button>
  <div id="report-content" class="report-content-section">
    <div class="report-content-inner">
      <div class="report-header">
        <img src="/assets/img/logoldpi.png" alt="Care4giver Logo" class="report-logo" />
        <span class="report-header-title">{{ 'loEditor.infoFormGroup.Title' | translate }}</span>
      </div>
      <ng-container *ngIf="surveyReport.length > 0; else noReport">
        <div *ngFor="let report of surveyReport" class="report-section" [attr.data-steptype]="report.stepType">
          <ng-container *ngIf="report.stepType === SurveyStepType.information; else normalSectionTitle">
            <h3 class="report-section-title">{{ getLangValue(report.reportDescription) }}</h3>
          </ng-container>
          <ng-template #normalSectionTitle>
            <h2 class="report-section-title">{{ getLangValue(report.reportDescription) }}</h2>
          </ng-template>
          <div *ngFor="let resp of report.responses" class="report-question-block">
            <span *ngIf="getLangValue(resp.reportDescription)" class="report-question">{{ getLangValue(resp.reportDescription) }}</span>
            <div *ngIf="resp.values?.length > 0; else noResponseBlock" class="report-answer-block">
              <span *ngFor="let val of resp.values; let last = last">
                <ng-container *ngIf="isJsonString(val); else plainValue">
                  <ng-container *ngIf="parseJsonValue(val) as parsed">
                    <ng-container *ngIf="isArray(parsed); else objectValue">
                      <ul class="survey-value-bold" style="display:inline; padding-left: 1em; margin:0;">
                        <li *ngFor="let item of parsed" style="display:inline; margin-right:0.5em;">{{ item }}</li>
                      </ul>
                    </ng-container>
                    <ng-template #objectValue>
                      <ng-container *ngIf="isObject(parsed); else fallbackJson">
                        <span class="survey-value-bold">
                          <ng-container *ngFor="let entry of (parsed | keyvalue); let last = last">
                            <ng-container *ngIf="resp.showValueInReport === true || (resp.showValueInReport === null && resp._id === 'other')">
                              {{ entry.value.toString() | translate }}<span *ngIf="!last">, </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                      <ng-template #fallbackJson>
                        <pre class="survey-value-bold">{{ prettyPrintJson(parsed) }}</pre>
                      </ng-template>
                    </ng-template>
                  </ng-container>
                </ng-container>
                <ng-template #plainValue>
                  <span *ngIf="resp.showValueInReport === true || (resp.showValueInReport === null && resp._id === 'other')" class="survey-value-bold">{{ val }}</span>
                </ng-template>
                <span *ngIf="!last">, </span>
              </span>
            </div>
            <ng-template #noResponseBlock>
              <div class="report-answer-block"><em>{{ 'survey.noResponse' | translate }}</em></div>
            </ng-template>
          </div>
          <div *ngIf="report.responses.length === 0 && report.stepType !== SurveyStepType.introduction" class="report-question-block">
            <span class="report-question">{{ getLangValue(report.reportDescription) }}</span>
            <div class="report-answer-block"><em>{{ 'survey.noResponse' | translate }}</em></div>
          </div>
        </div>
      </ng-container>
      <ng-template #noReport>
        <p>No survey report available.</p>
      </ng-template>
    </div>
  </div>
  <div class="bottom-row">
    <button mat-raised-button color="primary" (click)="exportToPdf()">Export to PDF</button>
  </div>
</div>
